(function () {
  'use strict';

  var EN = /^en/i.test(document.documentElement.lang || '');

  /* ----------------------------------------------------------
     1. Sélecteur de quantité (+ / -) sur les cartes de plats.
        Le champ « quantity » du thème n'est pas remplacé : les
        boutons écrivent dedans. Le formulaire d'ajout au panier
        reste donc exactement celui du thème.
     ---------------------------------------------------------- */
  function qtyInput(stepper) {
    if (!stepper) { return null; }
    var form = stepper.closest('form');
    return form ? form.querySelector('input[name="quantity"]') : null;
  }

  function render(stepper) {
    var input = qtyInput(stepper);
    if (!input) { return; }
    var value = parseInt(input.value, 10);
    if (!value || value < 1) { value = 1; input.value = '1'; }
    var output = stepper.querySelector('[data-pp-qty-val]');
    if (output) { output.textContent = String(value); }
    var minus = stepper.querySelector('[data-pp-qty-step="-1"]');
    if (minus) { minus.disabled = value <= 1; }
  }

  function renderAll() {
    var steppers = document.querySelectorAll('[data-pp-qty]');
    Array.prototype.forEach.call(steppers, render);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) { return; }
    var button = target.closest('[data-pp-qty-step]');
    if (!button) { return; }
    event.preventDefault();
    event.stopPropagation();
    var stepper = button.closest('[data-pp-qty]');
    var input = qtyInput(stepper);
    if (!input) { return; }
    var value = (parseInt(input.value, 10) || 1) + parseInt(button.getAttribute('data-pp-qty-step'), 10);
    if (value < 1) { value = 1; }
    if (value > 99) { value = 99; }
    input.value = String(value);
    render(stepper);
  });

  /* Le thème déclenche « product:added » AVANT d'envoyer le formulaire
     (form.serialize). On attend donc que l'envoi soit parti avant de
     remettre le compteur à 1, sinon le panier recevrait 1 au lieu du
     nombre choisi. Seul le formulaire envoyé est remis à 1. */
  document.addEventListener('product:added', function (event) {
    var form = event && event.detail && event.detail.closest ? event.detail.closest('form') || event.detail : null;
    window.setTimeout(function () {
      var steppers = form ? form.querySelectorAll('[data-pp-qty]') : document.querySelectorAll('[data-pp-qty]');
      Array.prototype.forEach.call(steppers, function (stepper) {
        var input = qtyInput(stepper);
        if (input) { input.value = '1'; }
        render(stepper);
      });
    }, 1500);
  });

  document.addEventListener('cart:html:updated', renderAll);

  /* ----------------------------------------------------------
     2. Heure limite du compte à rebours : « mercredi 23 h »
        devient « mercredi 23 h 59 ». Le calcul du thème utilise
        déjà 23:59, seul l'affichage omettait les minutes.
     ---------------------------------------------------------- */
  function fixCutoff(element) {
    var text = element.textContent;
    if (!text) { return; }
    var fixed = text.replace(/(\d{1,2}\s*h)(?!\s*\d)/, '$1 59');
    if (fixed === text) {
      fixed = text.replace(/(\d{1,2})\s+(a\.m\.|p\.m\.)/, '$1:59 $2');
    }
    if (fixed !== text) { element.textContent = fixed; }
  }

  function watchCutoff() {
    var nodes = document.querySelectorAll('#countdown-cutoff');
    Array.prototype.forEach.call(nodes, function (element) {
      fixCutoff(element);
      if (!window.MutationObserver) { return; }
      new MutationObserver(function () { fixCutoff(element); }).observe(element, {
        childList: true,
        characterData: true,
        subtree: true
      });
    });
  }

  /* ----------------------------------------------------------
     3. Pastille promotionnelle flottante.
        Elle suit la navigation sur toutes les pages et se ferme
        avec le X. La fermeture est mémorisée dans le navigateur
        du visiteur, par texte de promotion : si la promo change,
        la pastille réapparaît.
     ---------------------------------------------------------- */
  var PROMO_KEY = 'pp-promo-dismissed';

  function readDismissed() {
    try { return window.localStorage.getItem(PROMO_KEY); } catch (error) { return null; }
  }

  function writeDismissed(id) {
    try { window.localStorage.setItem(PROMO_KEY, id); } catch (error) { /* navigation privée */ }
  }

  function initPromo() {
    var promo = document.querySelector('[data-pp-promo]');
    if (!promo) { return; }

    /* Sorti de tout conteneur transformé pour que position: fixed tienne. */
    if (promo.parentNode !== document.body) { document.body.appendChild(promo); }

    var id = promo.getAttribute('data-pp-promo') || 'promo';
    if (readDismissed() === id) { promo.parentNode.removeChild(promo); return; }

    promo.classList.add('is-ready');
    window.setTimeout(function () { promo.classList.add('is-visible'); }, 600);

    var close = promo.querySelector('[data-pp-promo-close]');
    if (!close) { return; }
    close.addEventListener('click', function () {
      promo.classList.remove('is-visible');
      window.setTimeout(function () {
        if (promo.parentNode) { promo.parentNode.removeChild(promo); }
      }, 350);
      writeDismissed(id);
    });
  }

  /* ----------------------------------------------------------
     4. Barre « Passer à la caisse ».
        Apparaît dès que le panier contient un article, sur toutes
        les pages sauf le panier et la caisse. Le bouton mène
        directement à la caisse, après s'être assuré que la date de
        livraison est enregistrée dans le panier (mêmes attributs que
        la page panier). Si la date ne peut pas être calculée, ou si
        un abonnement ancien format exige le passage par ReCharge,
        le bouton mène à la page panier à la place.
     ---------------------------------------------------------- */
  var SKIP_PATH = /^\/(en\/)?(cart|checkouts?|account|challenge|password)/;
  var DAYS_EN = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var HEURE = '03:00 PM-09:00 PM';
  var bar = null;
  var lastCart = null;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function money(cents) {
    var fmt = (window.theme && window.theme.shop && window.theme.shop.money_format) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    if (/amount_with_comma_separator/.test(fmt)) { amount = amount.replace('.', ','); }
    return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, amount).replace(/<[^>]*>/g, '');
  }

  function cartPath(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + path;
  }

  function nextDelivery() {
    var el = document.querySelector('[data-pp-delivery]');
    if (!el || !window.ppDelivery) { return null; }
    var list = window.ppDelivery.upcoming(window.ppDelivery.readConfig(el));
    if (!list.length) { return null; }
    var d = list[0].date;
    return {
      value: pad(d.getUTCMonth() + 1) + '/' + pad(d.getUTCDate()) + '/' + d.getUTCFullYear(),
      day: DAYS_EN[d.getUTCDay()],
      label: d.toLocaleDateString(EN ? 'en-CA' : 'fr-CA', window.innerWidth < 600
        ? { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }
        : { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' })
    };
  }

  function hasLegacySubscription(cart) {
    return cart.items.some(function (item) {
      return item.properties && item.properties.shipping_interval_frequency;
    });
  }

  function buildBar() {
    bar = document.createElement('div');
    bar.className = 'pp-cartbar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', EN ? 'Your cart' : 'Votre panier');
    bar.innerHTML =
      '<a class="pp-cartbar__info" href="' + cartPath('/cart') + '">' +
        '<span class="pp-cartbar__line"><span class="pp-cartbar__count"></span> · <span class="pp-cartbar__total"></span></span>' +
        '<span class="pp-cartbar__date"></span>' +
      '</a>' +
      '<a class="pp-cartbar__go" href="' + cartPath('/cart') + '">' + (EN ? 'Checkout' : 'Passer à la caisse') + '</a>';
    document.body.appendChild(bar);
    bar.querySelector('.pp-cartbar__go').addEventListener('click', goCheckout);
  }

  function showBar(cart, pulse) {
    lastCart = cart;
    if (!cart || !cart.item_count) {
      if (bar) { bar.classList.remove('is-on'); }
      document.body.classList.remove('pp-has-cartbar');
      return;
    }
    if (!bar) { buildBar(); }
    var n = cart.item_count;
    bar.querySelector('.pp-cartbar__count').textContent = EN
      ? n + (n > 1 ? ' items' : ' item')
      : n + (n > 1 ? ' articles' : ' article');
    bar.querySelector('.pp-cartbar__total').textContent = money(cart.total_price);
    var next = nextDelivery();
    var dateEl = bar.querySelector('.pp-cartbar__date');
    dateEl.textContent = next ? (EN ? 'Ready on ' : 'Prêt le ') + next.label : '';
    dateEl.hidden = !next;
    /* Le script de date (pp-delivery.js) peut se charger après celui-ci. */
    if (!next && !showBar.retried) {
      showBar.retried = true;
      window.setTimeout(function () { if (lastCart) { showBar(lastCart, false); } }, 1500);
    }
    document.body.classList.add('pp-has-cartbar');
    void bar.offsetWidth; /* force le rendu initial pour que la transition joue */
    bar.classList.add('is-on');
    if (pulse) {
      bar.classList.remove('is-pulse');
      void bar.offsetWidth;
      bar.classList.add('is-pulse');
    }
  }

  function refreshBar(pulse) {
    if (SKIP_PATH.test(window.location.pathname)) { return; }
    fetch(cartPath('/cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { showBar(cart, pulse); })
      .catch(function () { /* la barre est un confort : on n'insiste pas */ });
  }

  function goCheckout(event) {
    event.preventDefault();
    var link = event.currentTarget;
    if (link.getAttribute('aria-busy') === 'true') { return; }
    link.setAttribute('aria-busy', 'true');
    var toCart = function () { window.location.href = cartPath('/cart'); };

    fetch(cartPath('/cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.item_count || hasLegacySubscription(cart)) { toCart(); return; }
        var next = nextDelivery();
        if (!next) { toCart(); return; }
        var a = cart.attributes || {};
        if (a['Date de livraison'] === next.value && a['Jour de livraison'] === next.day && a['Heure de livraison'] === HEURE) {
          window.location.href = cartPath('/checkout');
          return;
        }
        return fetch(cartPath('/cart/update.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: {
            'Date de livraison': next.value,
            'Jour de livraison': next.day,
            'Date Format': 'mm/dd/yy',
            'Heure de livraison': HEURE
          } })
        }).then(function (r) {
          if (!r.ok) { throw new Error('update'); }
          window.location.href = cartPath('/checkout');
        });
      })
      .catch(toCart);
  }

  document.addEventListener('product:added', function () {
    window.setTimeout(function () { refreshBar(true); }, 1600);
    window.setTimeout(function () { refreshBar(false); }, 4000);
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) { refreshBar(false); }
  });

  var booted = false;
  function boot() {
    if (booted) { return; }
    booted = true;
    renderAll();
    watchCutoff();
    initPromo();
    refreshBar(false);
  }

  /* Script chargé en « defer » : on attend DOMContentLoaded pour que les
     autres scripts (dont pp-delivery.js) soient prêts. « load » sert de filet. */
  if (document.readyState === 'complete') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
    window.addEventListener('load', boot);
  }
})();